import useMutationCall from "../../../hooks/useMutationCall";
import { usePatchProjectMutation } from "../projectsSlice";

const usePatchProject = () => {
  return useMutationCall(usePatchProjectMutation);
};

export default usePatchProject;
